import { createFileRoute } from '@tanstack/react-router';
// Route options read the light search module; the page is code-split with the component.
import { ConversationPage } from '@/features/chat/pages/conversation-page';
import { ConversationSearchSchema } from '@/features/chat/search';

/** One conversation. `?message=` scrolls to and highlights a message (mention notifications). */
export const Route = createFileRoute('/_auth/o/$orgId/chat/$channelId')({
  validateSearch: (search) => ConversationSearchSchema.parse(search),
  component: ConversationRoute,
});

function ConversationRoute() {
  const { orgId, channelId } = Route.useParams();
  const { message } = Route.useSearch();
  return <ConversationPage orgId={orgId} channelId={channelId} messageId={message} />;
}
